// extracted by mini-css-extract-plugin
export default {"headline":"PasswordResetForm-XSDMs__headline","btnToKeyCloak":"PasswordResetForm-KEn-a__btnToKeyCloak"};